import React, { useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import FeatureCard from "./utilities/FeatureCard";
import Footer from "./Footer";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import sample from "../assests/images/sample.svg";
import bulkExpression from "../assests/images/bulkexpression.svg";
import runiSort from "../assests/images/runisort-home.svg";
import fractionOutput from "../assests/images/fractionoutput.svg";
import hiresOutput from "../assests/images/hiresoutput.svg";
import { Link, useLocation } from "react-router-dom";
export default function Home() {
  const { isMobile, isDesktop } = useResponsiveFlags();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    // Wait for DOM content and then scroll to hash if exists
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Timeout allows DOM to finish rendering
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    }
  }, [location]);
  return (
    <>
      <div className="fullScreenLayout">
        <NavbarGuest />
        <section
          style={{
            background: "#E6F4FA",
            marginBottom: "1rem",
          }}
        >
          <div
            className={isDesktop ? "d-flex justify-content-between" : ""}
            style={{
              padding: isDesktop
                ? "96px 35px 62px 35px"
                : "62px 20px 62px 20px",
            }}
          >
            <p
              className="hometext1 heading"
              style={{ width: isDesktop ? "48%" : "100%" }}
            >
              iSort&trade; is a robust, AI-powered digital cytometry platform
              for quantifying cell type composition and gene expression — at the
              click of a button.
            </p>
            <p
              className="hometext2 para"
              style={{
                width: isDesktop ? "37%" : "100%",
                marginTop: isDesktop ? "0" : "2rem",
              }}
            >
              <p>
                <strong>iSort&trade;</strong> is built on <strong>CIBERSORT/x,</strong> the most widely used and extensively validated
                digital cytometry platform in the field, originally developed at Stanford University and exclusively 
                licensed to CiberMed.
              </p>
              <p>
                  CiberMed has further optimized, validated, and standardized the
                  CIBERSORT/x technology,{" "}
                  and offer the platform as <strong>iSort&trade;</strong>.
              </p>
              <p>
                With a simple RNA-seq workflow backed by AI-powered analysis, iSort&trade;
                enables
                <strong>
                  {" "}
                  fast, low cost, high throughput cellular profiling{" "}
                </strong>
                , bringing digital cytometry to the commercial market at scale for the first time.
              </p>
            </p>
          </div>
        </section>
        <div style={{ padding: isMobile ? "1rem" : "33px" }}>
          <div className="row" style={{ marginBottom: "3rem" }}>
            <section className="feature-cards-container">
              <FeatureCard
                title="Sample & Library Prep"
                description="Users may start with bulk tissue or blood gene expression data. iSort&trade; is robust to sample and library preparation methods. No tissue dissociation is required."
                icon={sample}
                border={isMobile ? "1px solid #ddd" : "None"}
              />
              <div className="vertical"></div>
              <FeatureCard
                title="Bulk Expression Profile"
                description="iSort&trade; is robust to RNA-seq platforms and alignment methods. Users may start with existing bulk expression data."
                icon={bulkExpression}
                border={isMobile ? "1px solid #ddd" : "None"}
              />
              <div className="vertical"></div>
              <FeatureCard
                title="Run iSort&trade;"
                description="Following data QC, simply upload data file and run iSort&trade; to generate an output in minutes."
                icon={runiSort}
                border={isMobile ? "1px solid #ddd" : "None"}
              />
              <div className="vertical"></div>
              <FeatureCard
                title="iSort&trade; Fractions Output"
                description="iSort&trade; Fractions quantifies cellular composition per sample from bulk expression data, using a predefined blood or tissue signature matrix."
                icon={fractionOutput}
                border={isMobile ? "1px solid #ddd" : "None"}
              />
              <div className="vertical"></div>
              <FeatureCard
                title="iSort&trade; HiRes Output"
                description="iSort&trade; HiRes infers cell-type-specific gene expression per sample from bulk expression data. Requires results from iSort&trade; Fractions."
                icon={hiresOutput}
                border={"None"}
              />
            </section>
          </div>
          {/* carousal menu */}
          <section className="py-5">
            <div className="row">
              <div className="col-12 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <p className="home-card-title ">iSort&trade; Fractions</p>
                    <p>
                      Starting with bulk gene expression data from blood or
                      tissue samples, iSort&trade; Fractions provides accurate
                      quantified cell composition for each sample, in minutes.{" "}
                    </p>
                    <ul>
                      <li>Free trial available</li>
                      <li>Run locally or in your browser</li>
                    </ul>
                    <div
                      className={`d-flex ${
                        !isDesktop ? "" : "justify-content-between"
                      }`}
                    >
                      <Link
                        to="/fractions"
                        className="btn learnmore-btn-home frac-btn-position"
                      >
                        Learn More
                      </Link>
                      <a
                        href="#getStartedWithFractions"
                        className="btn details-btn frac-btn-position"
                        style={{ marginTop: "1rem" }}
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <p className="home-card-title">iSort&trade; HiRes</p>
                    <p className="card-text">
                      iSort&trade; HiRes is the first AI powered tool for
                      inferring cell-type-specific gene expression per sample,
                      providing an even deeper level of insight into immune cell
                      makeup.{" "}
                    </p>
                    <ul>
                      <li>Free trial available</li>
                      <li>Run locally</li>
                    </ul>
                    <div
                      className={`d-flex ${
                        !isDesktop ? "" : "justify-content-between"
                      }`}
                    >
                      <Link to="/hires" className="btn learnmore-btn-home">
                        Learn More
                      </Link>
                      <a
                        href="#getStartedWithHiRes"
                        className="btn details-btn"
                        style={{ marginTop: "1rem" }}
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <p className="home-card-title">Data Science Services</p>
                    <div className="card-text">
                      <p>
                        <strong>
                          Create a custom signature matrix from scRNA data
                        </strong>
                      </p>
                      <p>
                        Cannot find cell types of your interest? A custom
                        signature matrix creation is currently offered as a data
                        science service by CiberMed.
                      </p>
                      <p>
                        Contact{" "}
                        <a href="mailto:support@cibermed.com">
                          support@cibermed.com
                        </a>{" "}
                        for more information.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* get started for fractions */}
          <section
            className="d-flex justify-content-between py-5"
            id="getStartedWithFractions"
          >
            <div className="get-started-container">
              <h2 className="header-title heading">
                Get Started with iSort&trade; Fractions
              </h2>
              <hr />
              <table className="table">
                <tbody>
                  <tr className="d-block d-lg-table-row">
                    <td
                      className="d-block d-lg-table-cell"
                      // style={{ width: "50%" }}
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    >
                      <p className="step-title step">STEP 1</p>
                      <p>
                        Register yourself and your organization using the
                        Register tab at the top of this page. You will receive
                        an e-mail from CiberMed once your account is approved.
                      </p>
                      <p className="pb-5">
                        <Link
                          className="cancel-btn btn"
                          to="/register"
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          Register
                        </Link>
                      </p>
                    </td>
                    <td
                      className="d-none d-lg-table-cell"
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    ></td>
                  </tr>
                </tbody>
              </table>
              <table className="table">
                <tbody>
                  <tr className="d-block d-lg-table-row">
                    <td
                      className="d-block d-lg-table-cell mt-2"
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    >
                      <p className="step-title step">STEP 2</p>

                      <p>
                        Select a token type of your choice to review terms and
                        conditions. Upon receipt of the signed agreement, a
                        token will be issued and you will receive the
                        notification email.
                      </p>
                    </td>
                    <td
                      className="d-block d-lg-table-cell"
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    >
                      <p
                        className={`${
                          !isDesktop ? "" : "d-flex justify-content-between"
                        } mb-4`}
                        style={{ marginTop: !isDesktop ? "1rem" : "2.3rem" }}
                      >
                        <span
                          className={`${
                            !isDesktop ? "sub-step-light" : "sub-step-bold"
                          }`}
                        >
                          Free trial token
                        </span>
                        {!isDesktop && <p></p>}
                        <Link to="/login" className="token-link sub-step-link">
                          View and sign agreement →
                        </Link>
                      </p>
                      {/* <br /> */}
                      <hr />
                      <p
                        className={`${
                          !isDesktop ? "" : "d-flex justify-content-between"
                        } my-4`}
                      >
                        <span
                          className={`${
                            !isDesktop ? "sub-step-light" : "sub-step-bold"
                          }`}
                        >
                          Per-sample token
                          {!!isDesktop && (
                            <span className="sub-step-light">
                              &nbsp;for light users
                            </span>
                          )}
                        </span>
                        {!isDesktop && <p></p>}
                        <Link to="/login" className="token-link sub-step-link">
                          View and sign agreement →
                        </Link>
                      </p>
                      {/* <br /> */}
                      <hr />
                      <p
                        className={`${
                          !isDesktop ? "" : "d-flex justify-content-between"
                        } my-4`}
                      >
                        <span
                          className={`${
                            !isDesktop ? "sub-step-light" : "sub-step-bold"
                          }`}
                        >
                          Annual seat-based token{" "}
                          {!!isDesktop && (
                            <span className="sub-step-light">
                              for heavy users
                            </span>
                          )}
                        </span>
                        {!isDesktop && <p></p>}
                        <a
                          href="https://www.cibermed.com/contact"
                          target="_blank"
                          rel="noreferrer"
                          className="token-link sub-step-link"
                        >
                          Contact CiberMed for discount
                        </a>
                      </p>
                      {/* <br /> */}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table style={{ marginBottom: isMobile ? "16px" : "" }}>
                <tbody>
                  <tr className="d-block d-lg-table-row">
                    <td
                      className="d-block d-lg-table-cell"
                      style={{
                        padding: "8px",
                        marginTop: isMobile ? "8px" : "",
                      }}
                    >
                      <p className="step-title step">STEP 3</p>
                      <p>
                        Run iSort&trade;. You can run iSort&trade; Fractions on
                        a browser or locally.
                      </p>

                      <p>
                        <b>Run iSort&trade; Fractions on a Browser</b>
                        <br />A user will upload the input file(s), run
                        iSort&trade; on browser, and download the results files.
                        <br /> See the <Link to="/login">Tutorial</Link> page
                        from Menu on the left for the instructions including how
                        to prepare your input file.
                      </p>
                      <p>
                        <b>Run iSort&trade; Fractions Locally</b>
                        <br />A user will download the desktop application
                        containerized by Docker, and runs it locally. No need to
                        upload your input file(s). The desktop version is a
                        command-line tool without GUI (graphical user
                        interface). The user guide can be downloaded from{" "}
                        <a
                          href="https://isort.cibermed.com/iSortFractions_UserGuide_latest.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          here
                        </a>
                        .
                      </p>
                    </td>
                    <td className="d-none d-lg-table-cell"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          {/* get started for Hires */}
          <section
            className="d-flex justify-content-between pb-5"
            id="getStartedWithHiRes"
          >
            <div className="get-started-container">
              <h2 className="header-title heading">
                Get Started with iSort&trade; HiRes
              </h2>
              <hr />
              <table className="table">
                <tbody>
                  <tr className="d-block d-lg-table-row">
                    <td
                      className="d-block d-lg-table-cell"
                      // style={{ width: "50%" }}
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    >
                      <p className="step-title step">STEP 1</p>
                      <p>
                        Register yourself and your organization using the
                        Register tab at the top of this page. You will receive
                        an e-mail from CiberMed once your account is approved.
                      </p>
                      <p className="pb-5">
                        <Link
                          className="cancel-btn btn"
                          to="/register"
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          Register
                        </Link>
                      </p>
                    </td>
                    <td
                      className="d-none d-lg-table-cell"
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    ></td>
                  </tr>
                </tbody>
              </table>
              <table className="table">
                <tbody>
                  <tr className="d-block d-lg-table-row">
                    <td
                      className="d-block d-lg-table-cell"
                      // style={{ width: "50%" }}
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    >
                      <p className="step-title step">STEP 2</p>
                      <p>
                        iSort&trade; HiRes requires iSort&trade; Fractions
                        results. Generate iSort Fractions results if you have
                        not done so.
                      </p>
                    </td>
                    <td
                      className="d-none d-lg-table-cell"
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    ></td>
                  </tr>
                </tbody>
              </table>
              <table className="table">
                <tbody>
                  <tr className="d-block d-lg-table-row">
                    <td
                      className="d-block d-lg-table-cell mt-2"
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    >
                      <p className="step-title step">STEP 3</p>

                      <p>
                        Select a token type of your choice to review terms and
                        conditions. Upon receipt of the signed agreement, a
                        token will be issued and you will receive the
                        notification email.
                      </p>
                    </td>
                    <td
                      className="d-block d-lg-table-cell"
                      style={{ width: !isDesktop ? "100%" : "50%" }}
                    >
                      <p
                        className={`${
                          !isDesktop ? "" : "d-flex justify-content-between"
                        } mb-4`}
                        style={{ marginTop: !isDesktop ? "1rem" : "2.3rem" }}
                      >
                        <span
                          className={`${
                            !isDesktop ? "sub-step-light" : "sub-step-bold"
                          }`}
                        >
                          Free trial token
                        </span>
                        {!isDesktop && <p></p>}
                        <Link to="/login" className="token-link sub-step-link">
                          View and sign agreement →
                        </Link>
                      </p>
                      {/* <br /> */}
                      <hr />
                      <p
                        className={`${
                          !isDesktop ? "" : "d-flex justify-content-between"
                        } my-4`}
                      >
                        <span
                          className={`${
                            !isDesktop ? "sub-step-light" : "sub-step-bold"
                          }`}
                        >
                          Per-sample token
                          {!!isDesktop && (
                            <span className="sub-step-light">
                              &nbsp;for light users
                            </span>
                          )}
                        </span>
                        {!isDesktop && <p></p>}
                        <Link to="/login" className="token-link sub-step-link">
                          View and sign agreement →
                        </Link>
                      </p>
                      {/* <br /> */}
                      <hr />
                      <p
                        className={`${
                          !isDesktop ? "" : "d-flex justify-content-between"
                        } my-4`}
                      >
                        <span
                          className={`${
                            !isDesktop ? "sub-step-light" : "sub-step-bold"
                          }`}
                        >
                          Annual seat-based token{" "}
                          {!!isDesktop && (
                            <span className="sub-step-light">
                              for heavy users
                            </span>
                          )}
                        </span>
                        {!isDesktop && <p></p>}
                        <a
                          href="https://www.cibermed.com/contact"
                          target="_blank"
                          rel="noreferrer"
                          className="token-link sub-step-link"
                        >
                          Contact CiberMed for discount
                        </a>
                      </p>
                      {/* <br /> */}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table style={{ marginBottom: isMobile ? "16px" : "" }}>
                <tbody>
                  <tr className="d-block d-lg-table-row">
                    <td
                      className="d-block d-lg-table-cell"
                      style={{
                        padding: "8px",
                        marginTop: isMobile ? "8px" : "",
                      }}
                    >
                      <p className="step-title step">STEP 4</p>
                      <p>
                        Run iSort&trade; HiRes. Currently iSort&trade; HiRes is
                        offered as a stand-alone module containerized by Docker.
                        The browser version will be coming soon.
                      </p>
                      <p>
                        <b>Run iSort&trade; HiRes Locally</b>
                        <br />A user will download the desktop application
                        containerized by Docker, and runs it locally. No need to
                        upload your input file(s). The desktop version is a
                        command-line tool without GUI (graphical user
                        interface). The user guide can be downloaded from{" "}
                        <a
                          href="https://isort.cibermed.com/iSortHiRes_UserGuide_latest.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          here
                        </a>
                        .
                      </p>
                    </td>
                    <td className="d-none d-lg-table-cell"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
        <div className="flex-grow-1"></div>
        <Footer />
      </div>
    </>
  );
}
